module.exports = __webpack_public_path__ + "img/ad3.a5a5e94e.png";